export const getFormattedHeight = (
  heightFt?: number,
  heightIn?: number,
): string => {
  return `${heightFt || 0}'${heightIn || 0}"`;
};
